import React from "react";
import { HomeHero } from "../components/home/HomeHero";
import { WhatWeDo } from "../components/home/WhatWeDo";
import { ConstantStandard } from "../components/home/ConstantStandard";
import { HomeSignals } from "../components/home/HomeSignals";
import { HowWeHelp } from "../components/HowWeHelp";
import { ProblemList } from "../components/ProblemList";
import { PhotoInterlude } from "../components/PhotoInterlude";
import { ClosingCTA } from "../components/ClosingCTA";
import { photos } from "../data/photography";
export function Home() {
  return <>
      <HomeHero data-id="element-727" data-mp="24ivapcawopbf" />
      <WhatWeDo showProcess={false} data-id="element-728" data-mp="29gdb2eauxw7t" />
      <PhotoInterlude image={photos.operatorCandid} label="Calm operations" statement="This is what payroll and HR technology feel like when someone capable has it handled." data-id="element-729" data-mp="29fc16d5kvfro" />
      <HowWeHelp data-id="element-730" data-mp="3kuqv182hprik" />
      <ConstantStandard data-id="element-731" data-mp="3kxd3d9x7gb1u" />
      <ProblemList title="When would you call us?" image={photos.rescueDesk} imageCaption="Experienced operators have arrived. Everything is under control." homeOnly closingCta data-id="element-732" data-mp="3owvpua4ocu6s" />
      <HomeSignals data-id="element-733" data-mp="2vxf5e4knl6h6" />
      <ClosingCTA data-id="element-734" data-mp="2vyzxzoneqfce" />
    </>;
}